import { apiGet } from '../api.ts'
import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { IAlertBio } from '@/api/notification/getNotificationBio.ts'
import { DISABLE_ALERTS_LIVE_FETCHING } from '@/constant/constant.ts'
import { MINUTE } from '@/constant/time.ts'

export const apiGetAlertBioLive = async () => {
    return await apiGet<IResAlertBioLive>(`/alert/bio/live`)
}

const useQueryGetAlertBioLive = (enabled = false) => {
    return useQuery({
        enabled: enabled,
        queryKey: QueryCacheKeys.notification.getAlertBioLive(),
        // 배회감지 중심이므로 생체알림은 5분마다 확인 (기존 1초에서 변경)
        refetchInterval: !DISABLE_ALERTS_LIVE_FETCHING ? 5 * MINUTE : false,
        queryFn: async () => {
            const { data } = await apiGetAlertBioLive()
            return data
        }
    })
}

export default useQueryGetAlertBioLive

export interface IResAlertBioLive {
    bios: IAlertBio[];
}